import type { DriveStep } from 'driver.js';

export const attorneySettingsSteps: DriveStep[] = [
  {
    element: '[data-tour="attorney-settings-profile"]',
    popover: {
      title: 'Your Profile',
      description: 'Name, phone, and firm details. Shown on invoices and client communications.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-settings-intake-url"]',
    popover: {
      title: 'Client Intake URL',
      description:
        'Copy or preview your custom intake form URL. Share with clients to receive case submissions.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-settings-billing"]',
    popover: {
      title: 'Stripe Billing',
      description: 'Connect Stripe to process payments and manage your subscription.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-settings-encryption"]',
    popover: {
      title: 'Encryption Setup',
      description: 'Set up a passphrase for end-to-end encryption of all sensitive case data.',
      side: 'right',
      align: 'center',
    },
  },
];
